document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        nav.style.display = 'flex';
        nav.style.position = 'absolute';
        nav.style.inset = '74px 0 auto';
        nav.style.flexDirection = 'column';
        nav.style.background = '#0a0a0a';
        nav.style.padding = '22px';
      } else {
        nav.removeAttribute('style');
      }
    });
  }
});
